import React from "react";

const FreeTierModalLink = ({ amplitudeKey, buttonText }) => (
  /* eslint-disable jsx-a11y/anchor-is-valid */
  <a
    data-amplitude={amplitudeKey}
    data-toggle="modal"
    data-target="#ask-ai-free-tier .modal"
    className="tw-cursor-pointer"
  >
    {buttonText}
  </a>
);

export default FreeTierModalLink;
